export default "__VITE_ASSET__CyGkOsFD__"